'use strict';

// TODO should investigate using enumify http://2ality.com/2016/01/enumify.html

/**
 * Helper object for enumerables that contain
 * constant values. By default all properties
 * that are created with Object.create are not
 * writeable and not configurable.
 */
const Enum = Object.create(
  {},
  {
    /**
     * Asserts given value; throws error
     * if not present in object's properties.
     *
     * @param {string} val The value to check for.
     * @return {boolean} True if value is member
     * of enumerable object properties.
     */
    assert: {
      enumerable: false,
      value: function(val) {
        if (!this.hasValue(val)) {
          throw new Error('Value ' + val + ' not member of object');
        }

        return true;
      },
    },

    /**
     * Checks if a given value is present in the
     * object's properties. Usage example:
     * if (!LockActions.hasValue('lock')) { console.log('invalid status'); }
     *
     * @param {string} val The value to check for.
     * @return {boolean} Whether or not the value exists in the object's properties.
     */
    hasValue: {
      enumerable: false,
      value: function(val) {
        for (let key in this) {
          if (Object.prototype.hasOwnProperty.call(this, key) && this[key] === val) {
            return true;
          }
        }

        return false;
      },
    },

    /**
     * Converts the object's enumerable values
     * to array and returns array.
     *
     * @return {Array} Array of object's enumerable values.
     */
    toArray: {
      enumerable: false,
      value: function() {
        const arr = [];

        for (let key in this) {
          if (Object.prototype.hasOwnProperty.call(this, key)) {
            arr.push(this[key]);
          }
        }

        return arr;
      },
    },
  }
);

module.exports = Enum;
